import NewAdministrator from "../../../../components/@users/administrators/NewAdministrator";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function AdministratorNewPage() {

    return (
        <NewAdministrator 
            routeType={routeTypes.admin}
        />
    )
}       